import { baseApi } from './baseApi';

const borrowerLoanApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    verifyBorrower: builder.mutation({
      query: ({ loanNumber, zip, phoneLast4 }) => {
        const params = new URLSearchParams({
          grant_type: 'urn:lk:borrower-verification',
          loan_number: loanNumber,
        });
        if (zip) params.set('zip_code', zip);
        if (phoneLast4) params.set('phone_last4', phoneLast4);
        return {
          url: '/auth/token',
          method: 'POST',
          body: params.toString(),
          contentType: 'application/x-www-form-urlencoded',
        };
      },
    }),
    getLoan: builder.query({
      query: () => ({
        url: '/borrower/loan',
        method: 'GET',
      }),
      providesTags: ['Loan'],
    }),
    getConditions: builder.query({
      query: () => ({
        url: '/borrower/loan/conditions',
        method: 'GET',
      }),
      providesTags: ['LoanDocuments'],
    }),
    uploadConditionDocument: builder.mutation({
      query: ({ conditionId, file }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: `/borrower/loan/conditions/${conditionId}/documents`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['LoanDocuments'],
    }),
  }),
});

export default borrowerLoanApi;
